import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { toast } from 'react-toastify';

import UnfollowDialog from '../Dialog/UnfollowDialog';
import { updateUserFollowingArtistsAction } from '../../store/actions/actionsMain';
import { httpsCallable } from 'firebase/functions';
import { firebaseFunctions } from '../../config/firebaseFunctions';

export default function FollowButton(props) {
  const dispatch = useDispatch();
  const router = useRouter();

  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const followingArtists = useSelector(
    (state) => state.authReducer.followingArtists,
  );

  const [loadingFollowBtn, setloadingFollowBtn] = useState(false);
  const [unfollowDialogState, setunfollowDialogState] = useState(false);

  const followClicked = async (e, artistId) => {
    setloadingFollowBtn(true);

    const followArtistAPI = httpsCallable(
      firebaseFunctions,
      'musicartFollowArtist',
    );
    followArtistAPI({
      artistId: artistId,
      follow: true,
    })
      .then((res) => {
        const modifiedArr = [...followingArtists];
        modifiedArr.push(artistId);
        updatefollowingArtists(modifiedArr);
        setloadingFollowBtn(false);

        if (props.onSuccessFollowCallback) {
          props.onSuccessFollowCallback();
        }
      })
      .catch((err) => {
        setloadingFollowBtn(false);

        toast.error('An error occured!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          zIndex: 2147483641,
        });
      });
  };

  const updatefollowingArtists = (arr) => {
    dispatch(updateUserFollowingArtistsAction(arr));
  };

  return (
    <>
      <button
        className={
          (userDataRedux &&
            userDataRedux.uid &&
            userDataRedux.uid === props.artistId) ||
          loadingFollowBtn ||
          !userDataRedux
            ? `author__follow  ${props.className ? props.className : ''}`
            : `author__follow ${props.className ? props.className : ''}`
        }
        type="button"
        onClick={(e) => {
          if (userDataRedux) {
            if (followingArtists && followingArtists.includes(props.artistId)) {
              setunfollowDialogState(true);
            } else {
              followClicked(e, props.artistId);
            }
          } else {
            router.push(`/auth/login?page=artist/${props.artistId}`);
          }
        }}
      >
        {loadingFollowBtn ? (
          <div className="flex justify-center	">
            <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
          </div>
        ) : followingArtists && followingArtists.includes(props.artistId) ? (
          'Following'
        ) : (
          'Follow'
        )}
      </button>

      <UnfollowDialog
        dialogState={unfollowDialogState}
        setdialogState={setunfollowDialogState}
        img={props.photoUrl ? props.photoUrl : '/img/unknow.jpg'}
        artistName={props.name ? props.name : '-'}
        artistId={props.artistId}
        followingArtistsIds={followingArtists}
        setfollowingArtistsIds={updatefollowingArtists}
        onSuccessUnFollowCallback={props.onSuccessUnFollowCallback}
      />
    </>
  );
}
